export function formatNumber(value) {
  return new Intl.NumberFormat('en-US', {
    maximumSignificantDigits: 3,
  }).format(value)
}

export function stackNumber(value) {
  return value > 1000 ? `$${Math.floor(value / 1000)}K` : `$${value}`
}

export function dollarNumber(value) {
  return `$${formatNumber(value)}`
}
